/* global femcare, OneTrust */

femcare.video.tiktokVideo = {
    /**
     * Initializes TikTok video functionality.
     * This method sets up the consent overlay and initializes TikTok videos by calling respective methods.
     */
    init: function () {
        this.handleConsentOverlay();
    },

    /**
     * Handles the display of the consent overlay for videos.
     * Binds a click event to the consent settings link which toggles the OneTrust consent display.
     */
    handleConsentOverlay() {
        $('.video-consent-overlay__text-settings-link').on('click', () => {
            OneTrust.ToggleInfoDisplay();
        });
    },

    /**
     * Initializes TikTok videos embedded within the site.
     * Iterates over each TikTok video wrapper, constructs the embed code using video ID and username,
     * and prepends the embed code to the `.tiktok-video` container only if it does not already contain an embed.
     */
    initTikTokVideos() {
        $('.tiktok-video__wrapper').each(function () {
            const $videoContainer = $(this).find('.tiktok-video');

            if ($videoContainer.find('.tiktok-embed').length === 0) {
                const videoId = $(this).data('tiktok-video-id');
                const userName = $(this).data('tiktok-video-username');

                const embedCode = `
                    <blockquote class="tiktok-embed" cite="https://www.tiktok.com/${userName}/video/${videoId}" data-video-id="${videoId}" style="max-width: 605px;min-width: 325px;">
                        <section>
                            <a target="_blank" title="${userName}" href="https://www.tiktok.com/${userName}?refer=embed">${userName}</a>
                        </section>
                    </blockquote>
                    <script async src="https://www.tiktok.com/embed.js"></script>
                `;

                $videoContainer.prepend(embedCode);
            }

            $videoContainer.css('background', 'transparent');
            $(this).find('.video-consent-overlay').hide();
        });
    }
};
